import { useEffect, useState } from "react";
import { TopInfo } from "../../components/top-info/top-info";
import SideBarConfiguration from "./components/sidebar-config";
import PersonalInfoForm from "../profile/components/personal-info-form";
import ChangePassForm from "../profile/components/change-pass-form";
import Users from "../users";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../services/atoms/auth.atoms";


const topInfo = { title: 'Configuraciones', subtitle: 'Descripción del módulo' };
const Configurations =() =>{
const user=useRecoilValue(userAtom)
    const [viewSelected, setViewSelected] = useState(
        localStorage.getItem('viewSelected') || "profile"
    );

    useEffect(()=>{
        const viewSave = localStorage.getItem('viewSelected')
        if(viewSave==="users" && !user?.data.isSuperAdmin){
            setViewSelected("profile")
        }
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        localStorage.setItem('viewSelected', viewSelected);
    }, [viewSelected]);

    return(
        <div className="gm-configurations-screen-container">
            <TopInfo info={topInfo}/>
            <main className="gm-main-configuration-container">
                <section>
                <SideBarConfiguration 
                setViewSelected={setViewSelected}
                viewSelected={viewSelected}
                />
                </section>
            <section style={{backgroundColor: 'white'}}>
                {viewSelected==="profile" && (
                    <PersonalInfoForm />
                )
                }
                {viewSelected=== "password" && (
                    <ChangePassForm />
                )}
                {viewSelected ==="users" && (
                    <Users />
                )}
                </section>
            </main>
        </div>
    )
}

export default Configurations;